import { render, staticRenderFns } from "./FileDirActions.vue?vue&type=template&id=70385ea5&scoped=true&"
import script from "./FileDirActions.vue?vue&type=script&lang=js&"
export * from "./FileDirActions.vue?vue&type=script&lang=js&"
import style0 from "./FileDirActions.vue?vue&type=style&index=0&id=70385ea5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70385ea5",
  null
  
)

export default component.exports